






















import Vue from 'vue';
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { IOldCustomSelectOption } from '@/common/interfaces/shared.interface';

interface ICartSelect {
  OpenIndicator: { render: (arg: (el: string, options: { class: string }) => HTMLElement) => unknown };
  selectedCart: IOldCustomSelectOption;
}

export default Vue.extend({
  name: `ProductPageSelect`,
  components: { VueSelect },
  data(): ICartSelect {
    return {
      OpenIndicator: {
        render: (createElement): HTMLElement => createElement(`span`, { class: `product-page-select__icon` }),
      },
      selectedCart: {
        code: -1,
        label: ``,
      },
    };
  },
  props: {
    options: {
      required: true,
      type: Array as () => IOldCustomSelectOption[],
    },
  },
  mounted(): void {
    [this.selectedCart] = this.options;
  },
});
